
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"23","viewBox":"0 0 30 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"30","height":"23","rx":"2","fill":"#122546"}}),_c('path',{attrs:{"d":"M15 4.625a6.875 6.875 0 100 13.75 6.875 6.875 0 000-13.75zm-1.375 9.281V9.094c0-.284.323-.445.55-.275l3.209 2.406a.344.344 0 010 .55l-3.209 2.406a.344.344 0 01-.55-.275z","fill":"#fff"}})])
          )
        }
      }
    